import {toast} from 'react-toastify';
import api from '../irelandApi';
import {
  GET_PUSH_NOTIFICATION_TEMPLATES_FULFILLED,
  GET_PUSH_NOTIFICATION_TEMPLATES_PENDING,
  GET_PUSH_NOTIFICATION_TEMPLATES_REJECTED,
  GET_PUSH_NOTIFICATION_TEMPLATE_PENDING,
  GET_PUSH_NOTIFICATION_TEMPLATE_REJECTED,
  GET_PUSH_NOTIFICATION_TEMPLATE_FULFILLED,
  GET_PUSH_NOTIFICATIONS_PENDING,
  GET_PUSH_NOTIFICATIONS_FULFILLED,
  GET_PUSH_NOTIFICATIONS_REJECTED,
  GET_PUSH_NOTIFICATION_PENDING,
  GET_PUSH_NOTIFICATION_FULFILLED,
  GET_PUSH_NOTIFICATION_REJECTED,
  POST_PUSH_NOTIFICATION_FULFILLED,
  POST_PUSH_NOTIFICATION_PENDING,
  POST_PUSH_NOTIFICATION_REJECTED,
  POST_PUSH_NOTIFICATION_TEMPLATE_FULFILLED,
  POST_PUSH_NOTIFICATION_TEMPLATE_PENDING,
  POST_PUSH_NOTIFICATION_TEMPLATE_REJECTED,
  DELETE_PUSH_NOTIFICATION_TEMPLATE_FULFILLED,
  DELETE_PUSH_NOTIFICATION_TEMPLATE_PENDING,
  DELETE_PUSH_NOTIFICATION_TEMPLATE_REJECTED,
} from '../reducers/pushNotificationsReducer';

export const getPushNotifications = (params = {sort: 'push_at', direction: 'desc'}) => (dispatch) => {
  dispatch({
    type: GET_PUSH_NOTIFICATIONS_PENDING,
  });

  return api.get('/api/admin/push_notifications', {params})
    .then((response) => {
      dispatch({
        type: GET_PUSH_NOTIFICATIONS_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PUSH_NOTIFICATIONS_REJECTED,
        payLoad: error.data
      });

      Promise.reject(error);
    });
};

export const getPushNotification = id => (dispatch) => {
  dispatch({
    type: GET_PUSH_NOTIFICATION_PENDING,
  });
  return api.get(`/api/admin/push_notifications/${id}`)
    .then((response) => {
      dispatch({
        type: GET_PUSH_NOTIFICATION_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PUSH_NOTIFICATION_REJECTED,
        payLoad: error.data
      });

      Promise.reject(error);
    });
};

export const getPushNotificationTemplates = () => (dispatch) => {
  dispatch({
    type: GET_PUSH_NOTIFICATION_TEMPLATES_PENDING,
  });
  return api.get('/api/admin/push_notification_templates')
    .then((response) => {
      dispatch({
        type: GET_PUSH_NOTIFICATION_TEMPLATES_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PUSH_NOTIFICATION_TEMPLATES_REJECTED,
        payLoad: error.data
      });

      Promise.reject(error);
    });
};

export const getPushNotificationTemplate = id => (dispatch) => {
  dispatch({
    type: GET_PUSH_NOTIFICATION_TEMPLATE_PENDING,
  });
  return api.get(`/api/admin/push_notification_templates/${id}`)
    .then((response) => {
      dispatch({
        type: GET_PUSH_NOTIFICATION_TEMPLATE_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PUSH_NOTIFICATION_TEMPLATE_REJECTED,
        payLoad: error.data
      });

      Promise.reject(error);
    });
};

export const savePushNotificationTemplate = (payLoad, callback) => (dispatch) => {
  dispatch({
    type: POST_PUSH_NOTIFICATION_TEMPLATE_PENDING,
  });

  return api.post('/api/admin/push_notification_templates', {
    push_notification_template: {
      ...payLoad,
      group_ids: payLoad.group_ids.map(group => +group.value)
    }
  })
    .then((response) => {
      dispatch({
        type: POST_PUSH_NOTIFICATION_TEMPLATE_FULFILLED,
        payLoad: response.data
      });

      callback();

      toast.success('New notification template has been created.');
    })
    .catch((error) => {
      dispatch({
        type: POST_PUSH_NOTIFICATION_TEMPLATE_REJECTED,
        payLoad: error.data
      });
      toast.error('Cannot save notification template.');

      Promise.reject(error);
    });
};

export const savePushNotification = (payLoad, callback) => (dispatch) => {
  dispatch({
    type: POST_PUSH_NOTIFICATION_PENDING,
  });
  return api.post('/api/admin/push_notifications', {
    push_notification: {
      ...payLoad,
      group_ids: payLoad.group_ids.map(group => +group.value)
    }
  })
    .then((response) => {
      dispatch({
        type: POST_PUSH_NOTIFICATION_FULFILLED,
        payLoad: response.data
      });

      callback();

      toast.success('Notification has been saved.');
    })
    .catch((error) => {
      dispatch({
        type: POST_PUSH_NOTIFICATION_REJECTED,
        payLoad: error.data
      });

      toast.error('Cannot save notification.');

      Promise.reject(error);
    });
};

export const deletePushNotificationTemplate = id => (dispatch) => {
  dispatch({
    type: DELETE_PUSH_NOTIFICATION_TEMPLATE_PENDING,
  });

  return api.delete(`/api/admin/push_notification_templates/${id}`)
    .then(() => {
      dispatch({
        type: DELETE_PUSH_NOTIFICATION_TEMPLATE_FULFILLED,
        payLoad: id
      });
    })
    .catch((error) => {
      dispatch({
        type: DELETE_PUSH_NOTIFICATION_TEMPLATE_REJECTED,
        payLoad: error.data
      });
      toast.error('Cannot delete notification template.');

      Promise.reject(error);
    });
};

export const downloadPushNotifications = () => api.get('/api/admin/push_notifications.csv', {headers: {Accept: 'text/csv'}});




// WEBPACK FOOTER //
// ./src/actions/pushNotifications.js